import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Package, ShoppingCart, Tag, Truck, LogOut, Users, FileText, Image, Building2, Percent, Award, Plug, History, TicketPercent, ShieldCheck, Mail, BarChart3, Briefcase, FolderKanban, MessageSquare } from "lucide-react";

const NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
    { to: "/admin/pedidos-orcamento", label: "Orçamentos", icon: MessageSquare },
    { to: "/admin/portfolio", label: "Portfolio", icon: FolderKanban },
    { to: "/admin/servicos", label: "Serviços", icon: Briefcase },
    { to: "/admin/produtos", label: "Produtos", icon: Package },
    { to: "/admin/encomendas", label: "Encomendas", icon: ShoppingCart },
    { to: "/admin/utilizadores", label: "Utilizadores", icon: Users },
    { to: "/admin/fornecedores", label: "Fornecedores", icon: Building2 },
    { to: "/admin/marcas", label: "Marcas", icon: Award },
    { to: "/admin/campanhas", label: "Campanhas", icon: Percent },
    { to: "/admin/cupoes", label: "Cupões", icon: TicketPercent },
    { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
    { to: "/admin/categorias", label: "Categorias", icon: Tag },
    { to: "/admin/transporte", label: "Transporte", icon: Truck },
    { to: "/admin/banners", label: "Banners", icon: Image },
    { to: "/admin/conteudos", label: "Conteúdos", icon: FileText },
    { to: "/admin/integracoes", label: "Integrações", icon: Plug },
    { to: "/admin/auditoria", label: "Histórico", icon: History },
    { to: "/admin/2fa", label: "Segurança 2FA", icon: ShieldCheck },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    return (
        <div className="min-h-screen bg-paper" data-testid="admin-layout">
            <header className="bg-ink text-white border-b-2 border-magenta sticky top-0 z-30">
                <div className="container-edge py-4 flex items-center justify-between">
                    <Link to="/admin" className="font-display font-black text-xl">
                        SOS<span className="text-magenta">TONERS</span>
                        <span className="ml-3 label-mono text-magenta">/ Admin</span>
                    </Link>
                    <div className="flex items-center gap-4">
                        <Link to="/" className="text-xs font-mono hover:text-magenta">
                            Ver loja ↗
                        </Link>
                        <span className="text-xs font-mono text-white/60 hidden md:inline">
                            {user?.email}
                        </span>
                        <button
                            onClick={() => { logout(); nav("/admin/login"); }}
                            className="border-2 border-magenta px-3 py-1 text-xs font-bold uppercase hover:bg-magenta"
                            data-testid="admin-logout"
                        >
                            <LogOut size={14} className="inline mr-1" />
                            Sair
                        </button>
                    </div>
                </div>
            </header>

            <div className="container-edge py-8 grid lg:grid-cols-[240px_1fr] gap-8">
                <aside className="lg:sticky lg:top-24 lg:self-start">
                    <nav className="border-2 border-ink bg-white">
                        {NAV.map(({ to, label, icon: Icon, end }) => (
                            <NavLink
                                key={to}
                                to={to}
                                end={end}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-5 py-4 border-b-2 last:border-b-0 border-ink/10 font-bold text-sm uppercase tracking-wider transition-colors ${
                                        isActive ? "bg-magenta text-white" : "hover:bg-ink hover:text-white"
                                    }`
                                }
                                data-testid={`admin-nav-${to.split("/").pop()}`}
                            >
                                <Icon size={16} /> {label}
                            </NavLink>
                        ))}
                    </nav>
                </aside>
                <main>
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
